import { Input } from '@/components/ui/input';

/**
 * GEN-25's free-text box. Presentational: the page owns the value and
 * debounces it (`useDebounced`, 200 ms — a keystroke is not a request).
 */
export function ListSearch({
  label,
  placeholder,
  value,
  onChange,
}: {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <Input
      type="search"
      aria-label={label}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="h-10 w-full text-sm"
    />
  );
}
